import React from 'react';
import { Icon } from 'semantic-ui-react';

const completedAlarmsShape = new Map();

completedAlarmsShape.set('level', {
  header: {
    title: 'common.level',
  },
  cell: {
    renderFn: (level, values) => {
      const severity = [];
      for (let i = 0; i < level; i++) {
        severity.push(<Icon key={i} name="attention" color={values.color} />);
      }
      return <div>{severity}</div>;
    },
  },
});

completedAlarmsShape.set('color', {
  header: {
    title: 'common.color',
  },
  cell: {
    renderFn: (value, values, t) => t(`common.${value}`),
  },
});

completedAlarmsShape.set('machineName', {
  header: {
    title: 'common.machine',
  },
});

completedAlarmsShape.set('hall', {
  header: {
    title: 'common.hall',
  },
});

completedAlarmsShape.set('duration', {
  header: {
    title: 'common.duration',
  },
});

completedAlarmsShape.set('start', {
  header: {
    title: 'common.start',
  },
});

completedAlarmsShape.set('end', {
  header: {
    title: 'common.end',
  },
});

export default completedAlarmsShape;



// WEBPACK FOOTER //
// ./src/shapes/completedAlarmsShape.js